module.exports = __webpack_public_path__ + "static/media/Protect.af83af7a.jpg";